/* eslint-disable */
import Swiper from 'swiper/bundle';

export default function initSwiper() {
  document.querySelectorAll('.carousel').forEach((carousel) => {
    const slider = carousel.querySelector('.swiper');
    const btnPrev = carousel.querySelector('.swiper-prev');
    const btnNext = carousel.querySelector('.swiper-next');

    const swiper = new Swiper(slider, {
      speed: 900,
      slidesPerView: 'auto',
      mousewheel: false,
      spaceBetween: 4,
      loop: false,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      on: {
        slideChangeTransitionStart: () => {
          slider.classList.add('is-animating');
        },
        slideChangeTransitionEnd: () => {
          slider.classList.remove('is-animating');
        },
      },
    });
  });

  document.querySelectorAll('.slider').forEach((carousel) => {
    const slider = carousel.querySelector('.swiper');
    const btnPrev = carousel.querySelector('.swiper-prev');
    const btnNext = carousel.querySelector('.swiper-next');

    const swiper = new Swiper(slider, {
      speed: 900,
      slidesPerView: 1,
      mousewheel: false,
      loop: false,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
    });
  });

  document.querySelectorAll('.slider-3').forEach((carousel) => {
    const slider = carousel.querySelector('.swiper');
    const btnPrev = carousel.querySelector('.swiper-prev');
    const btnNext = carousel.querySelector('.swiper-next');

    const swiper = new Swiper(slider, {
      speed: 900,
      spaceBetween: 20,
      slidesPerView: 3,
      mousewheel: false,
      loop: false,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
}
